import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiLock } from 'react-icons/fi';
import DashboardLayout from '../../pages/dashboard/layout';

/**
 * Aspirational upgrade wall shown to a guest on a feature that needs a real account
 * (AI tools, empathy circles, wallet). Not a dead-end — it sells the feature and links
 * to sign-up. The server also enforces these (verified-new middleware); this is UX.
 *
 * Renders inside DashboardLayout so the navbar stays visible — a walled tab must never
 * strand the guest without navigation.
 */
export default function GuestWall({ title, description }: { title: string; description: string }) {
  return (
    <DashboardLayout>
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-sm w-full text-center bg-base-100 border border-base-300 rounded-2xl p-8"
        >
          <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary/10 flex items-center justify-center">
            <FiLock className="w-6 h-6 text-primary" />
          </div>
          <h2 className="text-lg font-semibold mb-2">{title}</h2>
          <p className="text-sm text-base-content/60 mb-6">{description}</p>
          <Link to="/register" className="btn btn-primary w-full">
            Create a free account
          </Link>
          <p className="mt-3 text-xs text-base-content/50">
            Already have one?{' '}
            <Link to="/login" className="text-primary hover:underline">
              Log in
            </Link>
          </p>
        </motion.div>
      </div>
    </DashboardLayout>
  );
}
